import React from "react";
import {Link} from "react-router-dom";


import Axios from "axios";
import Store from "store";

import {reAuth} from "../../../utils/utils";
import User from "./User/User";

class Users extends React.Component {
    constructor(props) {
        super(props);
        reAuth();
        this.state = {
            token: Store.get('accessToken').token
        };
        //
        // this.handleSubmit = this.handleSubmit.bind(this);
        // this.handleChange = this.handleChange.bind(this);
        // this.getPlace = this.getPlace.bind(this);
        // this.readyMap = this.readyMap.bind(this);

        this.renderItems = this.renderItems.bind(this);
        this.fetchItems = this.fetchItems.bind(this);
    }


    componentDidMount() {
        if (this.state.token) {
            this.fetchItems();
        }
    }

    fetchItems() {
        Axios.get(process.env.REACT_APP_API_BASE + '/mgmt/users', {
            headers: {
                'Authorization': this.state.token
            },
        } ).then(response => {
            console.log(response);
            if (response.status === 200) {
                this.setState({
                    items: response.data
                })
            }
        }).catch(error => {
            console.log('error', error);
            if (error.response.status === 401) {
                console.log('attempting reauth');
                reAuth();
            }
        });
    }


    renderItems() {
        if (this.state.items) {
            return this.state.items.map((item, index) => {
                return (
                    <User key={"k-" + index} entry={item} />
                );
            });
        }
    }

    render() {

        return (
            <div className="container" id="main">
                <div className="row mb-5">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h1>Users</h1>
                        <Link to={"/dashboard/users/add-new"} className={"btn btn-primary"}>Add new</Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="  no-shadow no-border">
                            <div className="layout-grid-1 small-gap">
                                {this.renderItems()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

Users.propTypes = {};

export default Users;
